var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0872 22C16.4579 22 16.7895 21.7748 16.9279 21.4325C17.068 21.0902 16.9846 20.6982 16.7203 20.441L8.28169 12.0024L16.7203 3.56372C16.958 3.3367 17.0538 2.99795 16.9704 2.67871C16.8871 2.36124 16.6388 2.11294 16.3213 2.02958C16.002 1.94622 15.6633 2.042 15.4363 2.27965L6.35559 11.3603C6.00088 11.7151 6.00088 12.2897 6.35559 12.6444L15.4363 21.7251C15.6083 21.9007 15.8424 22 16.0872 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.deb9cdfe32f26f6b687e9dd31b69a4ea.svg";
export { ForwardRef as ReactComponent };